import moment from 'moment'
export const settings = {
    state: {
        minimumValue: null,
        minimumDate: '',
        maximumDate: moment().endOf('year').format('YYYY-MM-DD'),
        beforeCheckoutMessage: '',
        thresholdAmountMessage: '',
        thresholdAmount: null,
        externalSupplierMessage: ''
    },
    mutations: {
        SET_MINIMUM_VALUE(state, minimumValue) {
            state.minimumValue = minimumValue
        },
        SET_MINIMUM_DATE(state, minimumDate) {
            state.minimumDate = minimumDate
        },
        SET_MAXIMUM_DATE(state, maximumDate) {
            state.maximumDate = maximumDate
        },
        RESET_MINIMUM_VALUE(state, minimumValue) {
            state.minimumValue = null
        },
        SET_BEFORE_CHECKOUT_MESSAGE(state, beforeCheckoutMessage) {
            state.beforeCheckoutMessage = beforeCheckoutMessage
        },
        SET_THRESHOLD_AMOUNT_MESSAGE(state, thresholdAmountMessage) {
            state.thresholdAmountMessage = thresholdAmountMessage
        },
        SET_THRESHOLD_AMOUNT(state, thresholdAmount) {
            state.thresholdAmount = thresholdAmount
        },
        SET_EXTERNAL_SUPPLIER_MESSAGE(state, externalSupplierMessage) {
            state.externalSupplierMessage = externalSupplierMessage
        }
    },
    actions: {
        async fetchSettings({ commit, getters }) {
            return await new Promise((resolve, reject) => {
                this.$api.get('b2b/v2/orders/settings').then(response => {
                    commit('SET_MINIMUM_VALUE', response.data.data.minimum_value)
                    commit('SET_MINIMUM_DATE', response.data.data.minimum_date)
                    commit('SET_BEFORE_CHECKOUT_MESSAGE', response.data.data.b2b_before_checkout_message)
                    commit('SET_THRESHOLD_AMOUNT_MESSAGE', response.data.data.b2b_threshold_amount_message)
                    commit('SET_THRESHOLD_AMOUNT', response.data.data.b2b_threshold_amount)
                    commit('SET_EXTERNAL_SUPPLIER_MESSAGE', response.data.data.b2b_external_supplier_message)
                    resolve()
                })
            })
        },
        resetMinimumValue({ commit }) {
            commit('RESET_MINIMUM_VALUE')
        }
    },
    getters: {
        minimumValue: (state) => {
            return state.minimumValue
        },
        minimumDate: (state) => {
            return state.minimumDate
        },
        maximumDate: (state) => {
            return state.maximumDate
        },
        minimumDayValue: (state) => (dayInWeek) => {
            // add +1 for iso day of week
            const day = (dayInWeek + 1).toString()
            // find the minimum value for the current day
            for (const [key, value] of Object.entries(state.minimumValue)) {
                if(key === day) {
                    return value
                }
            }
        },
        isValueMinimum: (state, getters) => (dayInWeek, currentAddressId) => {
            const weekDayOrderSum = getters.weekDayOrderSum(dayInWeek, currentAddressId)
            return state.minimumValue !== null && weekDayOrderSum > 0 && weekDayOrderSum < getters.minimumDayValue(dayInWeek) && getters.customerAddressAvailibleDayInWeek(currentAddressId, dayInWeek)
        },
        beforeCheckoutMessage: (state) => {
            return state.beforeCheckoutMessage
        },
        thresholdAmountMessage: (state) => {
            return state.thresholdAmountMessage
        },
        thresholdAmount: (state) => {
            return state.thresholdAmount
        },
        externalSupplierMessage: (state) => {
            return state.externalSupplierMessage
        }
    }
}
